import React, { useState, useEffect } from "react";
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./CourierProcessTab3.css";

const CourierProcessTab3 = () => {
  const [couriers, setCouriers] = useState([]); // Original courier list
  const [reorderedCouriers, setReorderedCouriers] = useState([]); // Temporary reordered state
  const [message, setMessage] = useState("");

  // Fetch couriers from backend
  useEffect(() => {
    const fetchCouriers = async () => {
      try {
        const response = await axios.get("https://astrovidhya.in/api/couriers");
        setCouriers(response.data);
        setReorderedCouriers(
          response.data.filter((courier) => courier.active).sort((a, b) => a.priority - b.priority)
        );
      } catch (error) {
        console.error("Error fetching couriers:", error);
        setMessage("Failed to fetch couriers.");
      }
    };

    fetchCouriers();
  }, []);

  // Handle drag-and-drop reordering
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedOrder = Array.from(reorderedCouriers);
    const [moved] = updatedOrder.splice(result.source.index, 1);
    updatedOrder.splice(result.destination.index, 0, moved);

    // Update priority in local state
    updatedOrder.forEach((courier, index) => {
      courier.priority = index + 1; // Reassign priorities
    });

    setReorderedCouriers(updatedOrder);
  };

  // Save updated priority to backend
  const savePriority = async () => {
    try {
      const activeCouriers = reorderedCouriers.filter((courier) => courier.active);
      const priorityData = activeCouriers.map((courier) => ({
        id: courier._id,
        priority: courier.priority,
      }));
  
      await axios.post("https://astrovidhya.in/api/couriers/priority", { priorityData });
  
      // Re-fetch all couriers to ensure UI consistency
      const response = await axios.get("https://astrovidhya.in/api/couriers");
      setCouriers(response.data); // Update couriers with fresh data from backend
      setReorderedCouriers(
        response.data.filter((courier) => courier.active).sort((a, b) => a.priority - b.priority)
      );
  
      setMessage("Priority saved successfully.");
    } catch (error) {
      console.error("Error saving priority:", error);
      setMessage("Failed to save priority.");
    }
  };
  
  const toggleActiveState = async (id, active) => {
    try {
      // Update the backend
      const response = await axios.put(
        `https://astrovidhya.in/api/couriers/${id}/active`,
        { active }
      );
      const updatedCourier = response.data;
  
      // Update local states
      setCouriers((prev) =>
        prev.map((courier) =>
          courier._id === updatedCourier._id ? updatedCourier : courier
        )
      );
  
      // Update reorderedCouriers dynamically to include only active couriers
      setReorderedCouriers((prev) => {
        if (updatedCourier.active) {
          // Add newly activated courier and re-sort
          return [...prev, updatedCourier].sort((a, b) => a.priority - b.priority);
        } else {
          // Remove deactivated courier
          return prev.filter((courier) => courier._id !== updatedCourier._id);
        }
      });
  
      setMessage(`Courier ${updatedCourier.name} ${active ? "activated" : "deactivated"} successfully.`);
    } catch (error) {
      console.error("Error updating active state:", error);
      setMessage("Failed to update active state.");
    }
  };
  

  return (
    <div className="courier-priority-tab">
      <h2>Courier Priority Management</h2>
      <div className="panel-container">
        {/* Active/Inactive Couriers Panel */}
        <div className="active-inactive-panel">
          <h3>Active/Inactive Couriers</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {couriers.map((courier) => (
                <tr key={courier._id}>
                  <td>{courier.name}</td>
                  <td>{courier.active ? "Active" : "Inactive"}</td>
                  <td>
  <button
    onClick={() => toggleActiveState(courier._id, !courier.active)}
    style={{
      backgroundColor: courier.active ? "#65737e" : "#03c9d7",
      color: "white",
      border: "none",
      padding: "5px 10px",
      borderRadius: "5px",
    }}
  >
    {courier.active ? "Deactivate" : "Activate"}
  </button>
</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Priority Panel */}
        <div className="set-priority-panel">
          <h3>Set Courier Priority</h3>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="priorityList">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="priority-list"
                >
                  {reorderedCouriers.map((courier, index) => (
                    <Draggable
                      key={courier._id}
                      draggableId={courier._id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="priority-item"
                        >
                          {courier.name}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <button
            onClick={savePriority}
            className="save-priority-btn"
            
          >
            Save Priority
          </button>
        </div>
      </div>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default CourierProcessTab3;
